module.exports = __webpack_public_path__ + "img/Freek_02.c25ea916.jpg";